<template>
  <b-container>
    <h1>Schedule Advisor Meeting</h1>

    <div class="box">
      <b-list-group>
        <b-list-group-item v-for="user in users" :key="user.uuid">
          <b-row class="no-gutters">
            <b-col sm="2" class="text-center">
              <img
                class="img-fluid rounded-circle" style="width: 50px;"
                :src="user.avatar" :alt="user.first_name + ' ' + user.last_name"
              >
            </b-col>

            <b-col sm="6">
              <h3 class="mt-0 mb-4">
                {{ user.first_name }} {{ user.last_name }}
              </h3>

              <p class="mb-0">{{ user.bio }}</p>
            </b-col>

            <b-col sm="4" class="pt-2">
              <b-btn
                variant="primary" size="sm" block
                @click="setShowUserModal(user)"
              >
                View Calendar
              </b-btn>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>

    <schedule-modal
      :show="showScheduleModal" :user="user"
      @dismiss="showScheduleModal = false"
    />
  </b-container>
</template>

<script>
import ScheduleModal from '@/components/advisors/ScheduleModal'

export default {
  name: 'AuthRegisterSchedule',
  components: {
    ScheduleModal
  },
  data () {
    return {
      user: null,
      users: [],
      showScheduleModal: false
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.$http
        .get('users/advisors?page_count=6')
        .then(
          (res) => {
            this.users = res.data.data
          },
          () => {

          }
        )
    },
    setShowUserModal (user) {
      this.user = user
      this.showScheduleModal = true
    }
  }
}
</script>
